import { ClientsTableParams } from '..'
import { useClients } from '../context/client-context'
import { ClientsActionDialog } from './clients-action-dialog'
import { DeleteDialog } from '../../../components/delete-dialog'
import { toast } from '@/hooks/use-toast'
import { useTranslation } from 'react-i18next'
import { remove_client } from '@/api/client'
import { Client } from '../data/schema';

interface ClientsDialogsProps {
  params: ClientsTableParams
  setParams: React.Dispatch<React.SetStateAction<ClientsTableParams>>
  onClientUpdate?: (updatedClient: Client) => void;
}

export function ClientsDialogs(props : ClientsDialogsProps) {
  const i18n = useTranslation()
  const { open, setOpen, currentRow, setCurrentRow } = useClients()

  return (
    <>
      <ClientsActionDialog
        key='user-add'
        open={open === 'add'}
        onOpenChange={() => setOpen('add')}
        setParams={props.setParams}
        params={props.params}
      />

      {currentRow && (
        <>
          <ClientsActionDialog
            key={`user-edit-${currentRow.id}`}
            open={open === 'edit'}
            onOpenChange={() => {
              setOpen('edit')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            currentRow={currentRow}
            setParams={props.setParams}
            params={props.params}
            onUpdateSuccess={props.onClientUpdate}
          />

          <DeleteDialog
            key={`user-delete-${currentRow.id}`}
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            onDeleted={() => {
              toast({
                title: i18n.t('client_removed', { client: currentRow.name }),
              })
              props.setParams({ ...props.params })
            }}
            getDeleteName={() => currentRow.name}
            deleteRow={() => remove_client(currentRow.id)}
            deleteTitle={i18n.t('delete_client')}
          />
        </>
      )}
    </>
  )
}
